<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"    
      bottom
      fixed 
      temporary     
    >
    
      <v-list-item>        
        <v-list-item-content>
          <v-list-item-title>Filters</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    <v-divider></v-divider>

      <v-list-item>
        <v-list-item-content>
          <v-btn              
              elevation="2"        
              dark
              :color="secondScreen ? 'green':'blue-gray'"
              @click="changeSecondScreen()"          
              >
                {{`Second Screen ${secondScreen?"ON":"OFF"}`}}
          </v-btn>         
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="(filter) in visibleFilters"          
          :key="filter.id"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{filter.name}}              
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-select               
                :items="filter.options"
                item-text="value"
                return-object
                v-model="selectedFilter"                                             
                dense            
              >             
              </v-select>
            </v-list-item-subtitle>
             <v-btn
              :color="'blue-gray'"
              elevation="2"        
              dark
              @click="subscribeSelectedFilter()"          
              >
                Add
            </v-btn>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
          <v-list-item-title
            class="break-spaces"   
          >
            <v-chip
              v-for="(filter) in subscribedFilters"   
              :key="filter.optId"       
              class="ma-1"
              close
              color="green"
              text-color="white"
              @click:close="unsubscribeFilter(filter)"
            > {{filter.value}}
            </v-chip>
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-btn
            :color="'blue-gray'"
            elevation="2"        
            dark
            @click="resetSubscriptions"          
            >
              Reset
            </v-btn>
          </v-list-item-subtitle>   
          
          </v-list-item-content>
          
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-navigation-drawer
      v-model="langDrawer"    
      bottom
      fixed 
      temporary
    >
      <v-list-item>
          <v-list-item-content>
            <v-list-item-title              
            > Languages
            </v-list-item-title>
              <v-select 
                  label="Select your language"
                  :items="availableLangs"                       
                  v-model="language"
                  class="mt-2 ml-2"
                  solo
                ></v-select>
          </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>
    
    <v-navigation-drawer
          v-model="settingsDrawer"    
          bottom
          fixed 
          height="250"
          temporary

        >
      <v-list-item>    
        <v-list-item-content>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title              
            > 
            </v-list-item-title>
              <v-slider
                  v-model="fontSize"
                  :label="fontSizeObject.label"
                  :thumb-color="fontSizeObject.color"
                  
                ></v-slider>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title              
            > 
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>       
      </v-list>
    </v-navigation-drawer>


    <v-app-bar
      app
      dense
    >      
      <v-toolbar-title>
        <v-btn
        :color="isConnected ? 'blue-gray' : 'error'"
        elevation="2"        
        dark
        @click.stop="dialogs.connect = true"
        >
          {{isConnected ? channelName : 'START'}}
        </v-btn>
      </v-toolbar-title>
      <v-btn
        color="blue-gray"        
        elevation="2"        
        dark
        @click.stop="drawer = !drawer"
        v-if="isConnected && filters.length > 0"
        >
          Filters
      </v-btn>
      
      <v-btn
        color="blue-gray"        
        elevation="2"        
        dark
        @click.stop="langDrawer = !langDrawer"
        v-if="isConnected && channelName.toLowerCase() != 'ep'"
        >
          Languages
      </v-btn>

      <v-dialog  v-model="dialogs.connect" persistent max-width="290">      
        <v-card>
          <v-card-title class="headline">Setup</v-card-title> 
          <v-card-text>
            <v-form v-model="valid" v-on:submit.prevent="start">
              <v-text-field
                v-model="channelName"                
                label="Channel to connect"
                :rules="channelRules"
                required                      
              ></v-text-field>
              <span color="error" v-if="apiError.error">{{apiError.msg}}</span>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogs.connect = false ">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="start" :disabled="!valid">Connect</v-btn>
            <v-spacer></v-spacer>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer></v-spacer>
     <v-btn
        color="blue-gray"        
        elevation="2"        
        dark
        @click.stop="settingsDrawer = !settingsDrawer"        
        >
          Settings
      </v-btn>
    </v-app-bar>

    <v-main 
     v-if="isConnected" 
     :style = "fontStyle"
    >  
      <actions 
       :medias="medias" 
       :action="action"
       :language="language"       
      ></actions>
    </v-main>

  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import * as Mqtt from 'mqtt'
import * as kapi from '../tools/libKaClient.js'
import Actions from './Actions.vue'
// import { emptyObject } from '../tools/helpers.js'
// import * as kalliope from '../tools/kalliope.js'
// import Languages from '../tools/LanguageCodes.js'

export default {
  name: 'Home',

  components: {
    Actions
  },
  props: [ 'propChId', 'propChName', 'propFilters', 'propSecondScreen'],
  data: () => ({
    dialogs: {
      connect: false,
      settings: false
    },
    drawer: false,
    settingsDrawer: false,
    langDrawer: false,
    secondScreen: false,
    valid: false,
    channelRules: [
      v => !!v || 'Name is required',
    ],
    chInfo: {},
    channelName:'',
    medias:[],
    selectedFilter:{}, // TO REMOVE
    subscribedFilters: [],
    apiError: {
      error: false,
      msg: ''
    },
    client: null,
    action: {},
    allowedActionTypes:['text','video','audio','image']
  }),

  async mounted(){
    let res = {}
    console.log('DEBUG Home.vue Props', this.propChId, this.propChName,this.propFilters)
    if(this.propChName.length > 0){
      res = await kapi.getChannelbyName(this.apiServer,this.propChName)
      console.log("DEBUG Home.vue mounted getChannelbyName: ", res)
      if( res.length == 1 ){
        this.chInfo = res[0]
        this.channelName = this.propChName
        
        if (this.propSecondScreen)
          this.mqttConnect(this.topic + '/second-screen/')
        else
          this.mqttConnect(this.topic)
        
        if (this.propFilters.length > 0){
          let filtsOptions = []
          this.visibleFilters.forEach((f) => {
            filtsOptions  = filtsOptions.concat(f.options)
          })
          console.log("DEBUG Home.vue mounted filtsOptions : ", filtsOptions)
          this.propFilters.forEach((optId) => {
            let target = filtsOptions.find(f => f.optId == optId)
            this.selectedFilter = target
            this.subscribeSelectedFilter()
            console.log("DEBUG Home.vue mounted filtsOptions target: ", target)
          })
        }
      }      
    }
  },
  methods:{
    async start(){
      let res = {}
      console.log("DEBUG Home.vue start(): ", this.channelName,this.channelName.length)
      if (this.channelName.length > 0){
        res = await kapi.getChannelbyName(this.apiServer,this.channelName)
        console.log("DEBUG Home.vue start(): ", res)
        if( res.length == 1 ){
          this.chInfo = res[0]          
          this.mqttConnect(this.topic)
        }
      }
    },
    changeSecondScreen(){
      if(!this.secondScreen){
        this.client.unsubscribe(this.topic, (err) => {
              if (!err) {
                console.log("DEBUG Home.vue: Unsubscription OK to: ",this.topic)                
              }else{              
                console.log("DEBUG Home.vue: Unsubscription error",error)
              }
            })
        
        this.client.subscribe(this.topic + '/second-screen/', (err) => {
            if (!err) {
              console.log("DEBUG Home.vue: Subscription OK to: ",this.topic + '/second-screen/')
              this.secondScreen = true
            }else{              
              console.log("DEBUG Home.vue: Subscription error",error)
            }
          })
        
      }else{
        this.client.unsubscribe(this.topic + '/second-screen/', (err) => {
              if (!err) {
                console.log("DEBUG Home.vue: Unsubscription OK to: ",this.topic + '/second-screen/')
                this.secondScreen = false
              }else{              
                console.log("DEBUG Home.vue: Unsubscription error",error)
              }
            })
          this.client.subscribe(this.topic, (err) => {
            if (!err) {
              console.log("DEBUG Home.vue: Subscription OK to: ",this.topic)
            }else{              
              console.log("DEBUG Home.vue: Subscription error",error)
            }
          })
      }
    },
    subscribeSelectedFilter(){
      console.log("DEBUG Home.vue subscribeSelectedFilter: ",this.selectedFilter)
      let target = this.selectedFilter
      let resultTopic = this.topic + '/' + target.topic      
      this.client.subscribe(resultTopic, (err) => {
            if (!err) {
              console.log("DEBUG Home.vue: Subscription OK to: ",resultTopic)
              this.subscribedFilters.push(target)
            }else{              
              console.log("DEBUG Home.vue: Subscription error",error)
            }
          })
        this.selectedFilter = {}
    },
    unsubscribeFilter(filt){
      console.log("DEBUG Home.vue unsubscribeFilter: ",filt)
      let target = filt
      let resultTopic = this.topic + '/' + target.topic      
      this.client.unsubscribe(resultTopic, (err) => {
            if (!err) {
              console.log("DEBUG Home.vue: Unsubscription OK to: ",resultTopic)
              this.subscribedFilters = this.subscribedFilters.filter((f) => f.optId != target.optId)
            }else{              
              console.log("DEBUG Home.vue: Unsubscription error",error)
            }
          })
    },
    resetSubscriptions(){
      let targets = this.subscribedFilters
      targets.forEach((f) => {
        this.unsubscribeFilter(f)
      })
    },
    mqttConnect(topic){
      console.log("DEBUG Home.vue mqttConnect(): ",topic)    
      this.client = Mqtt.connect(this.mqttServer,{keepalive:5})
      this.client.on('connect',() =>{
        console.log("DEBUG Home.vue: MQTT connected")
          this.client.subscribe(topic, (err) => {
            if (!err) {
              console.log("DEBUG Home.vue: Subscription OK")
              this.dialogs.connect = false
              this.$store.dispatch('setConnected')
            }else{              
              console.log("DEBUG Home.vue: Subscription error",error)
            }
          })
      })
      this.client.on('end',this.onEnd)
      this.client.on('close',this.onClose)
      this.client.on('reconnect',this.onReconnect)
      this.client.on('message',this.onMessage)
      this.client.on('error',this.onMqttError)
    },
    onMessage(topic,message){
      console.log("DEBUG Home.vue onMessage: ",topic,message.toString())
      let action = kapi.parsePayload(JSON.parse(message.toString()))
      if (this.allowedActionTypes.includes(action.type))
        this.action = action
        if (action.vibration){
          window.navigator.vibrate(800)
        }      
    },
    onEnd(){
      console.log("DEBUG Home.vue: MQTT Connection Ended")
      this.$store.dispatch('setDisconnected')
    },
    onClose(){
      console.log("DEBUG Home.vue: MQTT Connection Closed")
      this.$store.dispatch('setDisconnected')
    },
    onReconnect(){

    },
    onMqttError(error){
      console.log("MQTT Connection Error: ",error)
    },
    getUUID(response){
      return response.data.fields.uuid
    },
    setError(message){
      this.apiError.error = true
      this.apiError.msg = message
    },
  },
  computed:{  
    localComputed(){

    },
    topic(){
      return this.chInfo.root_topic 
    },
    visibleFilters(){
      let lang = this.$store.state.language      
      let out = []
      let allowedFilts = this.filters.filter((filt) => filt.type != 'hidden' || filt.type != 'input')

      allowedFilts.forEach((filt) =>{
        let opts = []        
        filt.options.forEach((opt) => {
          let tmp = {}
          tmp.fid = filt.id
          tmp.name = filt.name[lang]
          tmp.optId = opt.id
          tmp.value = opt.value[lang]
          tmp.topic = opt.topic
          opts.push(tmp)
        })        
        out.push({name: filt.name[lang], options: opts})   
      })
      return out
    },
    availableLangs(){
      return Object.keys(this.chInfo).length > 0 ? this.chInfo.languages.map(lang => lang['language_value']) : []
    },
    fontStyle(){
      return {
        fontSize: this.fontSize + 'px'
      }
    },
    fontSizeObject(){
      return { 
          label: 'font size', 
          color: 'red' 
        }
    },
    filters:{
      get(){
        return Object.keys(this.chInfo).length ? this.chInfo.filters : []
      },
      set(value){

      }
    },
    language: {
        get(){
          this.$store.state.language
        },
        set(value){
          this.$store.dispatch('setLanguage',value)
        }
      },
    fontSize:{
      get(){        
        return this.$store.state.fontSize
      },
      set(value){
        this.$store.dispatch('setFontSize',value)
      }
    },
    ...mapState({
      mqttServer: state => state.mqttServer,
      apiServer: state => state.apiServer,
      isConnected: state => state.connected

    })
  }
};
</script>
<style>
html{
 /* overflow-y: hidden !important;*/
}
.break-spaces{
  white-space: break-spaces !important;
}
</style>
